import { useQuery } from '@tanstack/react-query';

import { getAccountingPeriodConfiguration } from './accountingPeriod';
import type { AccountingPeriodConfiguration } from './accountingPeriod.types';
import { ACCOUNTING_PERIOD_CONFIG_KEY } from './constants';

export const useGetAccountingPeriodConfiguration = () => {
  return useQuery<AccountingPeriodConfiguration>({
    queryKey: [ACCOUNTING_PERIOD_CONFIG_KEY],
    queryFn: getAccountingPeriodConfiguration,
  });
};
